/**
 * Redux middleware that mirrors every SCRAPE_JOB[S]_* action into the
 * unified scrape-flow debug log. Ships through `debugLog` so the line
 * lands in the same backend file as everything else.
 *
 * No-op when debug mode is off — the log helper itself short-circuits.
 */

import { debugLog, isDebugEnabled } from "../utils/debugLog";

const ACTION_PREFIX = /^scrapeJobs\//;

function summarize(action) {
  // Keep the payload tiny — the log line should fit on one screen.
  if (!action) return {};
  const out = {};
  if (action.job) {
    out.job_id = action.job.job_id;
    out.state = action.job.state;
    out.event_type = action.job.type;
  }
  if (action.jobs) {
    out.bulk_count = Array.isArray(action.jobs) ? action.jobs.length : 0;
  }
  if (action.lastSyncAt) {
    out.last_sync_at = action.lastSyncAt;
  }
  return out;
}

const scrapeJobsLoggerMiddleware = function (_api) {
  return function (next) {
    return function (action) {
      if (isDebugEnabled() && action && typeof action.type === "string" && ACTION_PREFIX.test(action.type)) {
        debugLog.info("redux", action.type, summarize(action));
      }
      return next(action);
    };
  };
};

export default scrapeJobsLoggerMiddleware;
